<template>
  <div class="table">
    <div class="container">
      <div class="box">
        <el-form :model="basicForm" ref="basicForm" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="检测窗口期" prop="windowTime">
                <el-input v-model="basicForm.windowTime" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="版本" prop="versionText">
                <el-input v-model="basicForm.versionText" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="fiveBitCode">
                <el-input v-model="basicForm.fiveBitCode" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品中文名称" prop="fiveBitCodeName">
                <el-input v-model="basicForm.fiveBitCodeName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工厂名称" prop="facilityName">
                <el-input v-model="basicForm.facilityName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="烹饪方式" prop="cookCodeText">
                <el-input v-model="basicForm.cookCodeText" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="修改备注" prop="updateReason" :rules="{required: true, message: '修改备注不能为空', trigger: 'blur'}">
                <el-input v-model="basicForm.updateReason" type="textarea" :rows="1" maxlength="1000" show-word-limit :disabled="isDisabled" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="box">
        <el-row>
          <div class="info_box_title">
            <p class="line"></p>
            <p class="info_title">Nutrition明细</p>
          </div>
        </el-row>
        <el-row>
          <el-form :model="detailForm" ref="detailForm">
            <el-table :data="detailForm.currentDetailList" max-height="425" border stripe style="width: 100%">
              <el-table-column v-for="(item,index) in detailForm.tableHeaderList" :prop="item.prop" :label="item.label" min-width="150" :key="index" :render-header="(h,obj) =>renderHeader(h,obj,item)">
                <template slot-scope="scope">
                  <el-form-item :prop="`currentDetailList.${scope.$index}.`+`${item.prop}`" :rules="item.required?{ required: true, message: '请输入*', trigger: ['blur', 'change']}:''">
                    <span v-if="item.prop=='windowTime'||item.prop=='version'">{{scope.row[item.prop]}}</span>
                    <el-input v-else v-model="scope.row[item.prop]" @input="propInput(scope.row,item.prop,$event)" :disabled="isDisabled" style="width:100%"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-row>
      </div>
      <el-row type="flex" justify="center" align="middle" style="margin-top:10px">
        <el-button type="primary" @click="onSave" v-acl="NUTR_REPORT_EDIT_DATA" :disabled="isSaveDisabled" :loading="isSaveLoading" v-if="!isDisabled">保存</el-button>
        <el-button plain @click="onCancel">取消</el-button>
      </el-row>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils"
import IcSelect from "@/components/common/icSelect";
import { inputChoiceService } from "@/api/common/input-choice";
export default {
  name: "nutritionAnalysisDetail",
  components: { IcSelect },
  props: ['detailObj'],
  data() {
    return {
      basicForm: {
        windowTime: "",
        versionText: "",
        fiveBitCode: "",
        fiveBitCodeName: "",
        facilityName: "",
        cookCodeText: "",
        updateReason: "",
      },
      detailForm: {
        currentDetailList: [],
        tableHeaderList: [],
      },
      rules: {},
      isDisabled: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      inspectId: "",
    }
  },
  watch: {
    detailObj: {
      handler(newV, oldV) {
        console.log("🚀 ~ file: griNutritionAnalysisDetail.vue:117 ~ handler ~ newV:", newV)
        if (newV) {
          var obj = JSON.parse(newV)
          console.log("🚀 ~ file: griNutritionAnalysisDetail.vue:120 ~ handler ~ obj:", obj)
          this.basicForm.windowTime = obj.windowTime
          this.basicForm.versionText = obj.versionText
          this.basicForm.fiveBitCode = obj.fiveBitCode
          this.basicForm.fiveBitCodeName = obj.fiveBitCodeName
          this.basicForm.facilityName = obj.facilityName
          this.basicForm.cookCodeText = obj.cookCodeText
          this.basicForm.updateReason = obj.updateReason
          this.detailForm.currentDetailList = [...obj.currentDetailList]
          this.detailForm.tableHeaderList = [...obj.tableHeaderList]
          this.inspectId = obj.inspectId
          this.isDisabled = obj.type == 'view' ? true : false
        }
      },
      immediate: true
    }
  },
  mounted() {
    // if (this.$route.query.type === 'view') {
    //   this.isDisabled = true
    // } else {
    //   this.isDisabled = false
    // }
    // this.getInfo()
  },
  methods: {
    // getInfo() {
    //   nutriApi.getNutritionDetail(this.$route.query.id).then(res => {
    //     console.log("🚀 ~ file: nutritionDetail.vue:309 ~ nutriApi.getNutritionDetail ~ res:", res)
    //     if (res.code == '200') {
    //       this.basicForm = res.data
    //       this.detailForm.tableHeaderList = res.data.tableHeaderList
    //       this.detailForm.currentDetailList = res.data.currentDetailList
    //     }
    //   })
    // },
    onSave() {
      this.$refs['basicForm'].validate((valid) => {
        if (valid) {
          this.$refs['detailForm'].validate((valid) => {
            if (valid) {
              var obj = Object.assign({}, this.basicForm)
              obj.tableHeaderList = this.detailForm.tableHeaderList
              obj.currentDetailList = this.detailForm.currentDetailList
              obj.updateReason = this.basicForm.updateReason
              obj.inspectId = this.inspectId
              obj.ignoreAttachment = true
              console.log("🚀 ~ file: griNutritionAnalysisDetail.vue:132 ~ this.$refs['detailForm'].validate ~ obj:", obj)
              this.isSaveDisabled = true
              this.isSaveLoading = true
              nutriApi.inspectSubmit(obj).then(res => {
                console.log("🚀 ~ file: nutritionDetail.vue:345 ~ nutriApi.inspectSubmit ~ res:", res)
                this.isSaveDisabled = false
                this.isSaveLoading = false
                if (res.code == '200') {
                  this.$message.success('保存成功')
                  this.$emit('closeDetail')
                } else if (res.code == '601') {
                  let str = res.msg;
                  str = str.replace(/\n/g, '<br>')
                  this.$confirm(str, {
                    // title: '导入错误信息',
                    // message: h('div', null, newArr),
                    showCancelButton: true,
                    confirmButtonText: '确认',
                    confirmButtonClass: "confirmButtonClass",
                    cancelButtonClass: "cancelButtonClass",
                    cancelButtonText: '取消',
                    customClass: "nutriUploadBtn",
                    type: 'warning'
                  }).then(() => {
                    obj.ignoreCheck = true
                    nutriApi.inspectSubmit(obj).then(res => {
                      if (res.code == '200') {
                        this.$message.success('保存成功')
                        this.$emit('closeDetail')
                      }
                    })
                  }).catch(() => {
                    this.$message.info('已取消')
                  })
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(error => {
                this.isSaveDisabled = false
                this.isSaveLoading = false
              })
            }
          })
        }
      })
    },
    onCancel() {
      this.$emit('onClose3')
    },
    propInput(row, prop, newVal) {
      console.log("🚀 ~ file: nutritionDetail.vue:458 ~ propInput ~ e:", newVal)
      console.log("🚀 ~ file: nutritionDetail.vue:458 ~ propInput ~ prop:", prop)
      console.log("🚀 ~ file: nutritionDetail.vue:458 ~ propInput ~ row:", row)
      // 只允许输入数字和小数点
      newVal = newVal.replace(/[^\d\.]/g, "");
      // 只保留小数点后两位
      newVal = newVal.replace(/^\D*([0-9]+\.[0-9]{0,2}).*$/, "$1");
      row[prop] = newVal;
    },
    renderHeader(h, { column, $index }, item) {
      if (item.required) {
        return h("span", [
          h("span", { class: "mandatory" }),
          h("span", column.label)
        ]);
      } else {
        return h("span", [
          h("span", column.label)
        ]);
      }
    },
    routerBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  border: 1px solid #eee;
  padding: 8px;
  margin-top: 10px;
}
.info_box_title {
  height: 30px;
}
.info_title {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  float: left;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
  float: left;
}
/deep/.el-upload--text {
  width: 100% !important;
}
</style>
  